import { StyleSheet } from 'aphrodite/no-important';
import { POSITION, COLORS, FONTS } from '../styles';

export default StyleSheet.create({
  introSection: {
    position: POSITION.RELATIVE,
    padding: '60px 20px 80px',
    background: COLORS.WHITE,

    ':after': {
      position: POSITION.ABSOLUTE,
      content: '""',
      width: '100%',
      height: 80,
      bottom: 0,
      left: 0,
      zIndex: 2,
      pointerEvents: 'none',
      background: `linear-gradient(to bottom right, ${COLORS.WHITE} 50%, ${COLORS.GRAY4} 50%)`,

      '@media (max-width: 768px)': {
        display: 'none',
      },
    },

    '@media (max-width: 768px)': {
      padding: '40px 20px',
    },
  },

  introInner: {
    position: POSITION.RELATIVE,
    maxWidth: 800,
    margin: '0 auto',
    zIndex: 10,
    ...FONTS.OPEN_SANS,
  },

  introTitle: {
    ...FONTS.RAMA_E,
    fontSize: 32,
    fontWeight: 700,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: COLORS.PINK,
    marginBottom: 30,
    lineHeight: 1.3,

    '@media (max-width: 768px)': {
      fontSize: 24,
    },
  },

  introParagraph: {
    fontSize: 16,
    lineHeight: 1.7,
    color: COLORS.GRAY5,
    marginBottom: 16,

    '@media (max-width: 768px)': {
      fontSize: 15,
    },

    ':nth-child(1n) > strong': {
      fontWeight: 700,
    },
  },
});
